import { button } from 'components/set/Chat/styles'

const emojiSize = '25px'

export const styles = () => ({
    luaButton: {
        ...button,
        userSelect: 'none',
        fontSize: emojiSize,
        marginLeft: '8px',
        borderRadius: '3px',
        '& img': {
            width: emojiSize,
            height: emojiSize,
            display: 'flex',
            alignItems: 'center',
        },
        '&:active': {
            borderStyle: 'none',
            boxShadow: 'inset 0px 0px 10px 4px rgba(0,0,0,0.6)',
        },
    },
})
